// ContactPage component - Contact layout using shared components
import React from 'react';
import HeaderOne from '../components/HeaderOne';
import Footer from '../components/Footer';
import PageHeader from '../../components/PageHeader.jsx';
import ContactOne from '../../components/ContactOne.jsx';
import GMap from '../../components/GMap.jsx';

const ContactPage: React.FC = () => {
  React.useEffect(() => {
  }, []);

  return (
    <div>
      <HeaderOne />
      <PageHeader title="Contact" />
      <ContactOne />
      <GMap />
      <Footer />
    </div>
  );
};

export default ContactPage;
